import {AxiosInstance} from "axios";

export interface TimelineItem {
    id: string;
    dose: number;
    recommended_at: string;
    matching_sale: {
        _source: { datetime: string };
        datetime: string;
    };
}

export default function (hdsClient: AxiosInstance) {
    return {
        async timeline(consumerKey: string, vaccinationSlug: string): Promise<TimelineItem[]> {
            return hdsClient.get("vaccination-timeline", {
                params: {
                    'consumer_key': consumerKey,
                    'vaccination': vaccinationSlug
                }
            })
                .then(response => response.data.data);
        }
    };
}
